import { DisplayedCarouselItemContext } from '@/providers/displayed-carousel-item';
import { useContext } from 'react';

export function useDisplayedCarouselItem() {
    const context = useContext(DisplayedCarouselItemContext);
    if (!context) {
        throw new Error(
            'useDisplayedCarouselItem must be used within DisplayedCarouselItemProvider'
        );
    }
    return context;
}
